module.exports = __webpack_public_path__ + "11f61ca564da05361edd3dc9b4b6dfa6.svg";